import React from 'react';
const Membership = ({userInfo}) => {
  return (
    <div className="rollingContent">
      <div className="contentImage08">
        <div className="downloadText">
            <img src={require('../images/member.png')} alt="member" />
        </div>
        <div className="dataList">
          <table cellPadding={0} cellSpacing={0} className="memberTbl">
            <colgroup>
                <col width="" />
                <col width="350px" />
                <col width="350px" />
            </colgroup>
            <thead>
              <tr className="header">
                <th></th>
                <th>무료</th>                
                <th>프리미엄 멤버십</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                  <td>가격</td>
                  <td>Free</td>
                  <td>13,900/1개월</td>
              </tr>
              <tr>
                  <td>고객 검색</td>
                  <td>O </td>
                  <td>O </td>
              </tr>
              <tr>
                  <td>고객 필터링</td>
                  <td>O </td>
                  <td>O </td>
              </tr>
              <tr>
                  <td>고객 데이터 엑셀업로드</td>
                  <td>X </td>
                  <td>O </td>
              </tr>
              <tr>
                  <td>지도 자동 마킹</td>
                  <td>X </td>
                  <td>O </td>
              </tr>
              <tr>
                  <td>업로드 가능 고객 수 </td>
                  <td>100명</td>
                  <td>1000명</td>
              </tr>
              <tr>
                  <td>생일축하 문자발송 </td>
                  <td>X </td>
                  <td>O </td>
              </tr>
              {/* <tr>
                  <td>정기 안부 문자발송 </td>
                  <td>X </td>
                  <td>O </td>
              </tr>             */}
            </tbody>
          </table>
        </div>
      </div>
  </div>
  );
}

export default Membership;